import { Controller } from '@hotwired/stimulus';
import Swal from 'sweetalert2';

export default class extends Controller<HTMLFormElement> {

    private submitting = false;

    connect(): void {
        this.element.addEventListener('submit', this.handleSubmit);
    }

    disconnect(): void {
        this.element.removeEventListener('submit', this.handleSubmit);
    }

    private handleSubmit = async (event: Event): Promise<void> => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.submitting) return;

        const form = this.element;
        const btn = form.querySelector<HTMLButtonElement>('button[type="submit"]');

        const confirmResult = await Swal.fire({
            title: '¿Copiar segmentaciones?',
            text: 'Se crearán las segmentaciones seleccionadas en la sede destino. Los elementos ya existentes se omitirán.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, copiar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            focusCancel: true,
        });

        if (!confirmResult.isConfirmed) return;

        this.submitting = true;
        btn?.setAttribute('disabled', 'disabled');

        try {
            const response = await fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
            });

            const raw = await response.text();
            let data: {
                success: boolean;
                message: string;
                summary?: Record<string, { created: number; skipped: number }>;
            };
            try {
                data = JSON.parse(raw);
            } catch {
                await Swal.fire({
                    title: 'Error',
                    text: `El servidor devolvió una respuesta inesperada (HTTP ${response.status}).`,
                    icon: 'error',
                    confirmButtonText: 'Cerrar',
                });
                return;
            }

            if (!data.success) {
                await Swal.fire({ title: 'Error', text: data.message, icon: 'error', confirmButtonText: 'Cerrar' });
                return;
            }

            let summaryHtml = '';
            if (data.summary) {
                const rows = Object.entries(data.summary)
                    .map(([label, counts]) => `<tr><td class="text-start">${label}</td><td>${counts.created}</td><td>${counts.skipped}</td></tr>`)
                    .join('');
                summaryHtml = `
                    <table class="table table-sm mt-3 mb-0">
                        <thead><tr><th class="text-start">Tipo</th><th>Creados</th><th>Omitidos</th></tr></thead>
                        <tbody>${rows}</tbody>
                    </table>`;
            }

            // Cerrar el modal de Bootstrap si está dentro de uno antes de mostrar el resumen
            const bsModal = form.closest('.modal');
            if (bsModal) {
                const instance = (window as any).bootstrap?.Modal?.getInstance(bsModal);
                instance?.hide();
            }

            await Swal.fire({
                title: '¡Copiadas!',
                html: `<p>${data.message}</p>${summaryHtml}`,
                icon: 'success',
                confirmButtonText: 'Cerrar',
            });

            window.location.reload();
        } catch (err) {
            console.error('[seg-clone] error:', err);
            await Swal.fire({ title: 'Error', text: 'No se pudo completar la operación.', icon: 'error', confirmButtonText: 'Cerrar' });
        } finally {
            btn?.removeAttribute('disabled');
            this.submitting = false;
        }
    };
}
